// extracted by mini-css-extract-plugin
export default {"navLeft":"navbar_navLeft__5Mbrz","navRight":"navbar_navRight__KRGoS"};